import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import SinglePicker from '../../controls/singlePicker';
import ProcessEquipment from './processEquipment';
import ProcessVessels from './processVessels';
import FloatingRoof from './floatingRoof';
import WindGirder from './windGirder';
import Structures from './structures';
import TankShell from './tankShell';
import TankRoof from './tankRoof';
import Decking from './decking';
import Stacks from './stacks';
import Piping from './piping';
export default class SurfaceAreaCalcModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: '',
      result: null // Must clear without passing 0 or string
    };
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleCalc = this.handleCalc.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }
  handleTypeChange(type) {
    this.setState({
      type,
      result: null // Must clear without passing 0 or string (PropType = num)
    });
  }
  handleCalc(result) {
    this.setState({
      result
    });
  }
  handleSave() {
    const {
      onSave
    } = this.props;
    const {
      result
    } = this.state;
    onSave(result);
    this.setState({
      result: null // Must clear without passing 0 or string (PropType = num)
    });
  }
  handleClose() {
    const {
      onHide
    } = this.props;
    this.setState({
      result: null // Must clear without passing 0 or string (PropType = num)
    });
    onHide();
  }
  render() {
    const {
      show
    } = this.props;
    const {
      result,
      type
    } = this.state;
    const props = {
      result,
      onCalc: this.handleCalc
    };

    // Init the SurfaceAreaTypes
    const surfaceAreaTypes = [{
      id: 'Structures',
      name: 'Structural Steel, Platforms, Stairs, Handrails, Ladders'
    }, {
      id: 'Decking',
      name: 'Decking, Gratings, Ceiling, Roof, Floors, Walls'
    }, {
      id: 'Stacks',
      name: 'Stacks, Columns'
    }, {
      id: 'TankShell',
      name: 'Tank Shell'
    }, {
      id: 'TankRoof',
      name: 'Tank Roof'
    }, {
      id: 'FloatingRoof',
      name: 'Floating Roof'
    }, {
      id: 'WindGirder',
      name: 'Wind Girder'
    }, {
      id: 'ProcessEquipment',
      name: 'Process Equipment'
    }, {
      id: 'ProcessVessels',
      name: 'Process Vessels, Supports'
    }, {
      id: 'Piping',
      name: 'Piping, Valves, Flanges, Supports'
    }];
    const forms = {
      Structures: /*#__PURE__*/React.createElement(Structures, props),
      Decking: /*#__PURE__*/React.createElement(Decking, props),
      Stacks: /*#__PURE__*/React.createElement(Stacks, props),
      TankShell: /*#__PURE__*/React.createElement(TankShell, props),
      TankRoof: /*#__PURE__*/React.createElement(TankRoof, props),
      FloatingRoof: /*#__PURE__*/React.createElement(FloatingRoof, props),
      WindGirder: /*#__PURE__*/React.createElement(WindGirder, props),
      ProcessEquipment: /*#__PURE__*/React.createElement(ProcessEquipment, props),
      ProcessVessels: /*#__PURE__*/React.createElement(ProcessVessels, props),
      Piping: /*#__PURE__*/React.createElement(Piping, props)
    };
    return /*#__PURE__*/React.createElement(Modal, {
      isOpen: show,
      toggle: this.handleClose
    }, /*#__PURE__*/React.createElement(ModalHeader, {
      closebutton: "true"
    }, "Surface Area Calculator"), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "Select Surface Type",
      labelKey: "name",
      onChange: this.handleTypeChange,
      options: surfaceAreaTypes,
      placeholder: "Select...",
      value: type,
      returnValueKey: "id"
    }), type in forms ? forms[type] : undefined), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      onClick: this.handleSave
    }, "Save"), /*#__PURE__*/React.createElement(Button, {
      onClick: this.handleClose
    }, "Close")));
  }
}
SurfaceAreaCalcModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};